<script lang="ts" setup>
import type { MarkerOptions } from 'fifa-gis-library'
import { computed, inject, onUnmounted, ref, shallowRef, watch } from 'vue'

import { useFifaGisMap } from '../use-fifa-gis-map'

interface Props {
  marker?: Partial<MarkerOptions>
}

const props = defineProps<Props>()

const fifaGisMap = inject('fifaGisMap', ref(null))
const fifaGisMapLoaded = inject('fifaGisMapLoaded', ref(false))

const { preparePoint } = useFifaGisMap()

const instance = shallowRef(null)

const isReady = computed(() => fifaGisMap.value && fifaGisMapLoaded.value)

watch(
  [isReady, () => props.marker],
  () => {
    if (!isReady.value) return

    if (!props.marker && instance.value) {
      instance.value.dispose()
    }

    if (instance.value) {
      instance.value.update(preparePoint(props.marker))
    } else {
      instance.value = fifaGisMap.value.addMarker(preparePoint(props.marker))
    }
  },
  { immediate: true },
)

onUnmounted(() => {
  if (instance.value) {
    instance.value.dispose()
  }
})
</script>

<template lang="pug"></template>
